import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BankSearch;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import memoize from 'lodash/memoize';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconPlusLine } from '@instructure/ui-icons';
import { Button, CondensedButton } from '@instructure/ui-buttons';
import { Checkbox } from '@instructure/ui-checkbox';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import { AccessibleContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import TagSuggestSelect from '../../../common/components/shared/TagSuggestSelect';
import { interactionTypesNameDictionary } from '../../../common/util/interactionTypeMetadata';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Flex, TextInput, withStyleOverrides } from '@instructure/quiz-common';
var tagShape = PropTypes.shape({
  tag: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string.isRequired
  }).isRequired,
  count: PropTypes.number.isRequired
});
export var BankSearch = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BankSearch = /*#__PURE__*/function (_Component) {
  function BankSearch() {
    var _this2;
    _classCallCheck(this, BankSearch);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BankSearch, [].concat(args));
    _defineProperty(_this2, "toggleInteraction", memoize(function (it) {
      return function () {
        return _this2.props.toggle('interactionTypes', it);
      };
    }));
    _defineProperty(_this2, "setTags", function (tags) {
      return _this2.props.setFilter('tags', tags);
    });
    _defineProperty(_this2, "updateSearch", function (_ref) {
      var value = _ref.target.value;
      return _this2.props.update(value);
    });
    return _this2;
  }
  _inherits(BankSearch, _Component);
  return _createClass(BankSearch, [{
    key: "renderFilters",
    value: function renderFilters() {
      var _this3 = this;
      var _this$props = this.props,
        allInteractions = _this$props.allInteractions,
        search = _this$props.search,
        showFilters = _this$props.showFilters,
        toggleAllInteractions = _this$props.toggleAllInteractions,
        interactionTypes = _this$props.interactionTypes;
      if (showFilters) {
        var its = interactionTypes;
        var shown = allInteractions ? its : its.slice(0, 5);
        var active = search.get('interactionTypes');
        var interactionFilters = shown.map(function (_ref2) {
          var count = _ref2.count,
            it = _ref2.interaction_type;
          var interactionName = interactionTypesNameDictionary(it);
          var label = "".concat(interactionName, " (").concat(count, ")");
          return jsx("div", {
            key: it.id,
            css: _this3.props.styles.interactionType
          }, jsx(Checkbox, {
            checked: active.has(it.id),
            label: label,
            onChange: _this3.toggleInteraction(it.id),
            value: "medium"
          }));
        });
        var suggestions = this.props.tags.map(function (_ref3) {
          var tag = _ref3.tag;
          return tag;
        });
        var activeTags = this.props.search.get('tags');
        var tagSelect = jsx(TagSuggestSelect, {
          noMatchText: t('No matching tags found'),
          parentType: "Bank",
          parentId: "0",
          onChange: this.setTags,
          tags: activeTags,
          defaultSuggestions: suggestions
        });
        var toggleButton = function toggleButton() {
          if (shown.length < its.length || allInteractions) {
            var hide = function hide() {
              return t('Show Less');
            };
            var show = function show() {
              return t('Show More');
            };
            var text = allInteractions ? hide() : show();
            return jsx(CondensedButton, {
              onClick: toggleAllInteractions,
              margin: "none small"
            }, jsx(AccessibleContent, {
              alt: text
            }, text));
          }
        };
        return jsx("div", {
          css: this.props.styles.filterContainer
        }, jsx("div", {
          css: this.props.styles.filterColumn
        }, tagSelect), jsx("div", {
          css: this.props.styles.filterColumn
        }, jsx(View, {
          margin: "none small"
        }, jsx(Text, {
          weight: "bold",
          color: "primary"
        }, t('Question Type'))), interactionFilters, toggleButton()));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        showFilters = _this$props2.showFilters,
        toggleFilters = _this$props2.toggleFilters;
      return jsx("div", null, jsx(Flex, {
        as: "div"
      }, jsx(Flex.Item, {
        shouldGrow: true,
        shouldShrink: true
      }, jsx(TextInput, {
        renderLabel: jsx(ScreenReaderContent, null, t('Search')),
        type: "search",
        placeholder: t('Search'),
        onChange: this.updateSearch,
        value: this.props.search.get('text', '') || '',
        "data-automation": "sdk-bank-search-input"
      })), jsx(Flex.Item, null, jsx(Button, {
        onClick: toggleFilters,
        margin: "none none none small",
        renderIcon: IconPlusLine,
        "data-automation": "sdk-search-filter-button"
      }, jsx(AccessibleContent, {
        alt: showFilters ? t('Hide search filters') : t('Show search filters')
      }, t('Filters'))))), this.renderFilters());
    }
  }]);
}(Component), _defineProperty(_BankSearch, "displayName", 'BankSearch'), _defineProperty(_BankSearch, "componentId", "Quizzes".concat(_BankSearch.displayName)), _defineProperty(_BankSearch, "propTypes", {
  allInteractions: PropTypes.bool,
  interactionTypes: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    interaction_type: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string
    })
  })),
  showFilters: PropTypes.bool,
  tags: PropTypes.arrayOf(tagShape),
  toggleFilters: PropTypes.func.isRequired,
  toggleAllInteractions: PropTypes.func.isRequired,
  search: ImmutablePropTypes.map.isRequired,
  toggle: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_BankSearch, "defaultProps", {
  allInteractions: false,
  interactionTypes: [],
  showFilters: false,
  tags: []
}), _BankSearch)) || _class);
export default BankSearch;